const SELECTOR = '.client-compilations__share-block.ya-share2';

function patchMaxShareLinks() {
  document.querySelectorAll(SELECTOR).forEach((block) => {
    try {
      if (!block.classList.contains('ya-share2_inited')) {
        return;
      }

      const title = block.dataset.title || '';
      const url = block.dataset.url || '';

      if (!url.startsWith('http')) {
        return;
      }

      const maxUrl = `https://max.ru/:share?${new URLSearchParams({
        text: [title, url].filter(Boolean).join(' '),
        utm_source: 'share2',
      })}`;

      block.querySelectorAll('.ya-share2__item_service_max .ya-share2__link').forEach((link) => {
        link.href = maxUrl;
      });
    } catch (error) {
      // Share2 DOM changed — skip block, page keeps working.
    }
  });
}

function initMaxShareLinks() {
  patchMaxShareLinks();

  if (typeof MutationObserver === 'undefined') {
    return;
  }

  document.querySelectorAll(SELECTOR).forEach((block) => {
    new MutationObserver(patchMaxShareLinks).observe(block, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
      childList: true,
    });
  });
}

if (document.querySelector(SELECTOR)) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMaxShareLinks, { once: true });
  } else {
    initMaxShareLinks();
  }
}